import type { FaireProductEntity } from "../../entity_types/product";

export const p_8ezhjtx3p7: FaireProductEntity = {
  token: "p_8ezhjtx3p7",
  type: "product",
  name: "Linen Olea Bag",
  brandToken: "b_4uyrnv7cr8",
  brandName: "Live Linen",
  imageUrl: "https://cdn.faire.com/fastly/c90a4f25fa70527defd52a98cb1b50afcdd74a74458354b3538ecf2f3eec87c3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21fbc8614fdce95b556638de09133c7b22cde5fe2a44aa55cf4f309d46e397f5.jpeg",
    "https://cdn.faire.com/fastly/289da11bc9f10e93af7b375b631a6f5bf027590626b51842b80571d902bddbc6.jpeg",
    "https://cdn.faire.com/fastly/6cde63c091c5bf80366f35c480da7416cf8b43897be1544f427ab54dd2414921.jpeg"
  ],
  priceDollars: 35.5,
  description: "Our Linen Olea Bag carries the feel of slow and sunlit days. They go beautifully well with any pastel outfit. Celebrate the purest of European Linen here at Live Linen.\n\n• Includes one Handbag\n• Made from 100% European Linen\n• Dimensions: 45 x 40 cm (W x H)",
  tags: [],
  msrpDollars: 71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:51.503Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
